export enum StudyTypeEnum {
    Stochastic = 1,
    Energy = 2,
    IntraDayVol = 3,
    ovnVol = 4,
    closingVol = 5,
    rsi = 6,
    geometricMean = 7,
    simpleMa = 8,
    ema = 9,
    momentum = 10,
    PriceChannel = 11,
    MovingAverage = 12,
    TechnicalLines = 13,
}

export class StudyType {
    public static GetByValue(value: number) {
        switch (value) {
            case 1:
                return StudyTypeEnum.Stochastic;
            case 2:
                return StudyTypeEnum.Energy;
            case 3:
                return StudyTypeEnum.IntraDayVol;
            case 4:
                return StudyTypeEnum.ovnVol;
            case 5:
                return StudyTypeEnum.closingVol;
            case 6:
                return StudyTypeEnum.rsi;
            case 7:
                return StudyTypeEnum.geometricMean;
            case 8:
                return StudyTypeEnum.simpleMa;
            case 9:
                return StudyTypeEnum.ema;
            case 10:
                return StudyTypeEnum.momentum;
            case 11:
                return StudyTypeEnum.PriceChannel;
            case 12:
                return StudyTypeEnum.MovingAverage;
            case 13:
                return StudyTypeEnum.TechnicalLines;
            default:
                throw new Error("STUDYTYPE GetByValue() - Invalid value");
        }
    }

    public static GetFromText(text: string) {
        switch (text.toLowerCase()) {
            case "stochastic":
                return StudyTypeEnum.Stochastic;
            case "energy":
                return StudyTypeEnum.Energy;
            case "intraday":
                return StudyTypeEnum.IntraDayVol;
            case "overnight":
                return StudyTypeEnum.ovnVol;
            case "closing":
                return StudyTypeEnum.closingVol;
            case "price channel":
                return StudyTypeEnum.PriceChannel;
            case "moving average":
                return StudyTypeEnum.MovingAverage;
            default:
                throw new Error("GetFromText() - Invalid study from string");
        }
    }

    public static isOHLCStudy(study: StudyTypeEnum) {
        switch(study) {
            case StudyTypeEnum.PriceChannel:
                return true;
            case StudyTypeEnum.MovingAverage:
                return true;
            default:
                return false;
        }
    }

    public static getStudyWrapper(study: StudyTypeEnum, yAxisId: string): any {
        switch(study) {
            case StudyTypeEnum.TechnicalLines:
                return {
                    id: 'technicalLines',
                    name: 'Technical Lines',
                    yAxis: yAxisId,
                    type: 'line',
                    showInLegend: true,
                    legendIndex: 5
                };
            case StudyTypeEnum.PriceChannel:
                return {
                    id: 'priceChannel',
                    name: 'Price Channel',
                    yAxis: yAxisId,
                    type: 'line',
                    showInLegend: true,
                    legendIndex: 4
                };
            case StudyTypeEnum.MovingAverage:
                return {
                    id: 'movingAverage',
                    name: 'Moving Average',
                    yAxis: yAxisId,
                    type: 'line',
                    showInLegend: true,
                    legendIndex: 3
                };
            case StudyTypeEnum.Energy:
                return {
                    id: 'energyModel',
                    name: 'Energy Model',
                    yAxis: yAxisId,
                    type: 'line',
                    showInLegend: true,
                    legendIndex: 2
                };
            case StudyTypeEnum.Stochastic:
                return {
                    id: 'stochastic',
                    name: 'Stochastic',
                    yAxis: yAxisId,
                    type: 'line',
                    showInLegend: true,
                    legendIndex: 1
                };
            default:
                return undefined;
        }
    }
};